import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  STATUS_CODE_BANK_CARD_UN_OPEN_PAY: 6815002,
  STATUS_OPEN_CARD_SMS_CODE_ERROR: 6815003,
}, km({
    INSTALLMENT_GETINSTALLMENTBANKS_SUCCESS: null,
    INSTALLMENT_GETINSTALLMENTBANKS_ERROR: null,
    INSTALLMENT_GETINSTALLMENTPAYPERIODS_SUCCESS: null,
    INSTALLMENT_GETINSTALLMENTPAYPERIODS_ERROR: null,
    INSTALLMENT_SENDPAYSMS_SUCCESS: null,
    INSTALLMENT_SENDPAYSMS_ERROR: null,
    INSTALLMENT_COMMITINSTALLMENT_SUCCESS: null,
    INSTALLMENT_COMMITINSTALLMENT_ERROR: null,
    INSTALLMENT_CHECKISBANKCARDSUPPORT_SUCCESS: null,
    INSTALLMENT_CHECKISBANKCARDSUPPORT_ERROR: null,
    INSTALLMENT_OPENBANKCARDPAYMENT_SUCCESS: null,
    INSTALLMENT_OPENBANKCARDPAYMENT_ERROR: null,
    INSTALLMENT_SENDSMSFOROPENPAY_SUCCESS: null,
    INSTALLMENT_SENDSMSFOROPENPAY_ERROR: null,
    INSTALLMENT_TOOPENPAY_SUCCESS: null,
    INSTALLMENT_TOOPENPAY_ERROR: null,
    INSTALLMENT_CHECKPAYRESULT_SUCCESS: null,
    INSTALLMENT_CHECKPAYRESULT_ERROR: null,
    /*yeoman-template-point-1*/
}))
